import {configTC} from "../../constant/initDrawing";
import {useSocket} from "../../helpers/socket";
import Live2TCWrapper from "../../components/live2/tc/Live2TCWrapper";

const config = {
    ...configTC,
    type: "tn",
    subFixType: "minhngoc"
}

const Live2TNBlack830Page = () => {
    const {socket} = useSocket({platform: `tn_minhngoc_website`})
    return <Live2TCWrapper socket={socket} config={config}/>
}

export default Live2TNBlack830Page;